(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$q', '$injector'];

    function authExpiredInterceptor($q, $injector) {

        var service = {
            response: response,
            responseError: responseError
        };

        return service;

        function response(response) {
            // If we have a request and the session was expired we receive a response with status 200 and the following message:
            // "This session has been expired (possibly due to multiple concurrent logins being attempted as the same user)."
            if (response.status === 200
                    && response.data == 'This session has been expired (possibly due to multiple concurrent logins being attempted as the same user).') {

                var UserData = $injector.get('UserData');
                UserData.expireSession();

                doLogout();

                response.data = '';
            }
            return response;
        }

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/users/current') < 0) {
                doLogout();
                if (response.data.path.indexOf('/login') < 0) {
                    // Add the intercepted property to the response, so intercepted errors cannot be triggered again
                    response.intercepted = true;
                }
            }
            return $q.reject(response);
        }

        function doLogout() {
            var $state = $injector.get('$state');
            if ($state.current.name != 'login') {

                var LoginService = $injector.get('LoginService');
                var RequestService = $injector.get('RequestService');

                var modalInstance = LoginService.alertNotificationModalConstructor('sessionExpired');
                modalInstance.closed.then(LoginService.logout);

                RequestService.cancelRequests();

            }
        }
    }
})();
